/**
 * 权限指令 v-auth
 * 用于控制按钮或元素的显示/隐藏，基于用户权限
 * 用法: v-auth="'permission:code'"
 */

// 默认导出指令对象
const authDirective = {
  mounted(el, binding) {
    const { value } = binding
    if (value) {
      // 这里可以实现权限检查逻辑
      // 暂时放行所有权限检查，如果需要权限控制可以在这里添加逻辑
      const hasPermission = checkPermission(value)
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}

// 权限检查函数
function checkPermission(permission) {
  // 可以从 store 或 localStorage 获取用户权限列表
  // 暂时返回 true 允许所有
  // 如需实现真实权限控制，请取消下面的注释并完善逻辑
  
  // const userPermissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  // return userPermissions.includes(permission)
  
  return true
}

/**
 * 自动聚焦指令 v-focus
 * 用于在元素挂载时自动获取焦点
 * 用法: v-focus
 */
const focusDirective = {
  mounted(el) {
    el.focus()
  }
}

/**
 * 数字输入指令 v-enter-number
 * 用于限制输入框只能输入数字，可指定小数位数
 * 用法: v-enter-number="2" (允许2位小数)
 */
const enterNumberDirective = {
  mounted(el, binding) {
    const decimalPlaces = binding.value !== undefined ? binding.value : 2
    const regExp = new RegExp(`^\\d*\\.?\\d{0,${decimalPlaces}}$`)
    
    const handler = function(e) {
      const val = e.target.value
      // 如果不是数字或不符合小数位数要求，则恢复上一次的值
      if (!regExp.test(val)) {
        e.target.value = val.slice(0, -1)
      }
    }
    
    el.addEventListener('input', handler)
    el._enterNumberHandler = handler
  },
  unmounted(el) {
    if (el._enterNumberHandler) {
      el.removeEventListener('input', el._enterNumberHandler)
    }
  }
}

// 注册指令的辅助函数
export function setupAuthDirective(app) {
  app.directive('auth', authDirective)
  app.directive('focus', focusDirective)
  app.directive('enter-number', enterNumberDirective)
}

export default authDirective
export { focusDirective, enterNumberDirective }
